import React, { useCallback, useEffect, useRef, useState } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { routes } from './routes/routes';
import Router from './routes/Router';
import Theme from './components/Theme/Theme';
import { LocalizationProvider } from './locale/localizationContext';
import { useAppSelector } from './redux/core';
import { isAppInitializedSelector } from './redux/general/general.selectors';
import { loadMaps } from './hooks/useDesktopGoogleApi';
import LoaderFullPage from './components/LoaderFullPage/LoaderFullPage';
import {
  authTokenSelector,
  isEmailConfirmedSelector,
} from './redux/user/user.selectors';
import { ErrorBoundary } from 'react-error-boundary';
import GeneralError from './components/GeneralError/GeneralError';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { Config } from './helpers/config';
import { useSetupPosteReview } from './hooks/usePosteReview';

type AppProps = {};

export const App: React.FC<AppProps> = () => {
  const isAppInitialized = useAppSelector(isAppInitializedSelector);
  const hasToken = useAppSelector(authTokenSelector);
  const isEmailConfirmed = useAppSelector(isEmailConfirmedSelector);
  const ref = useRef<HTMLIFrameElement>(null);

  const isAuthenticated: boolean = isEmailConfirmed && !!hasToken;

  const [isMapInitialized, setIsMapInitialized] = useState(false);

  const [posteReviewProvider, state] = useSetupPosteReview(ref?.current);
  let PosteReviewProvider = posteReviewProvider as any;

  useEffect(() => {
    loadMaps(() => {
      setIsMapInitialized(true);
    });
  }, []);

  const fallback = useCallback(() => <GeneralError />, []);

  return (
    <>
      <iframe
        key={'poste-review-iframe'}
        id={`poste-review-iframe`}
        src="/review-frame.html"
        width="100%"
        height="100%"
        ref={ref}
        style={{
          visibility: state.visible ? 'visible' : 'hidden',
          margin: '0',
          border: '0',
          padding: '0',
          overflow: 'hidden',
          position: 'fixed',
          top: state.visible ? '0' : '10000000px',
          left: state.visible ? '0' : '10000000px',
          bottom: '0',
          right: '0',
          zIndex: 999999,
        }}
      ></iframe>
      <BrowserRouter>
        <PosteReviewProvider>
          <Theme>
            <LocalizationProvider>
              {!isAppInitialized || !isMapInitialized ? (
                <LoaderFullPage show={true} />
              ) : (
                <GoogleOAuthProvider clientId={Config.googleSignInClientId!}>
                  <ErrorBoundary fallbackRender={fallback}>
                    <Router authorized={isAuthenticated} routes={routes} />
                  </ErrorBoundary>
                </GoogleOAuthProvider>
              )}
            </LocalizationProvider>
            <LoaderFullPage />
          </Theme>
        </PosteReviewProvider>
      </BrowserRouter>
    </>
  );
};

export default App;
